import React from 'react';

// Один раз добавляем keyframes анимации спиннера в документ
const SPINNER_KEYFRAMES_ID = 'report-generate-spinner-keyframes';
if (typeof document !== 'undefined' && !document.getElementById(SPINNER_KEYFRAMES_ID)) {
  const style = document.createElement('style');
  style.id = SPINNER_KEYFRAMES_ID;
  style.textContent = '@keyframes reportGenerateSpin { to { transform: rotate(360deg); } }';
  document.head.appendChild(style);
}

const ReportGenerateButton = ({ disabled, loading, onClick, label = 'Сформировать' }) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled || loading}
    style={{
      padding: '10px 20px',
      backgroundColor: '#6c757d',
      color: 'white',
      border: 'none',
      borderRadius: '4px',
      cursor: (disabled || loading) ? 'not-allowed' : 'pointer',
      fontSize: '14px',
      fontWeight: '500',
      minWidth: '140px',
      opacity: disabled ? 0.55 : 1,
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px',
    }}
    onMouseOver={(e) => {
      if (!disabled && !loading) {
        e.currentTarget.style.backgroundColor = '#5a6268';
      }
    }}
    onMouseOut={(e) => {
      if (!disabled && !loading) {
        e.currentTarget.style.backgroundColor = '#6c757d';
      }
    }}
  >
    {loading && (
      <span
        aria-hidden="true"
        style={{
          width: '16px',
          height: '16px',
          border: '2px solid rgba(255, 255, 255, 0.4)',
          borderTopColor: '#fff',
          borderRadius: '50%',
          animation: 'reportGenerateSpin 0.7s linear infinite',
          flexShrink: 0,
        }}
      />
    )}
    {loading ? 'Формирование…' : label}
  </button>
);

export default ReportGenerateButton;
